import {
  Box,
  Button,
  Drawer,
  IconButton,
  useMediaQuery,
} from "@material-ui/core";
import { Close, Menu } from "@material-ui/icons";
import clsx from "clsx";
import { TFunction } from "next-i18next";
import React, { useState } from "react";
import useStyles from "../../../styles/components/Navbar";
import UserProfileIcon from "../../../public/img/UserProfileIcon";

type MenuNavbarProps = {
  readonly t: TFunction;
  onClickAuth?: () => void;
  isLogin: boolean;
};

const MenuNavbar = (props: MenuNavbarProps) => {
  const { t, onClickAuth, isLogin } = props;
  const classes = useStyles();
  const tabScreen = useMediaQuery("(max-width:768px)");
  const [openNavbar, setOpenNavbar] = useState(false);

  return (
    <Box className={classes.navbarWrapper}>
      <Box className={clsx(classes.navbarContent, classes.navbarMenuWrapper)}>
        <img
          src={process.env.NEXT_PUBLIC_COLOR_LOGO}
          alt="logo"
          className={classes.logo}
        />
        {!tabScreen ? (
          <ul className={classes.menuWrapper}>
            <li
              className={classes.menu}
              onClick={() => {
                window.open(
                  `https://wa.me/${
                    process.env.WHATSAPP_DEFAULT || "6288802870057"
                  }`,
                  "_blank"
                );
              }}
            >
              {t("contact")}
            </li>
            {onClickAuth && !isLogin && (
              <li className={classes.menu}>
                <Button
                  color="primary"
                  variant="contained"
                  disableElevation
                  className={classes.loginButton}
                  onClick={onClickAuth}
                >
                  {t("login")}
                </Button>
              </li>
            )}
            {isLogin && (
              <IconButton className={classes.iconButton} onClick={onClickAuth}>
                <UserProfileIcon />
              </IconButton>
            )}
          </ul>
        ) : (
          <Box className={classes.mobileIconWrapper}>
            {isLogin && (
              <IconButton className={classes.iconButton} onClick={onClickAuth}>
                <UserProfileIcon />
              </IconButton>
            )}
            <Menu
              className={classes.icon}
              onClick={() => setOpenNavbar(true)}
            />
          </Box>
        )}
        <Drawer
          anchor="top"
          open={openNavbar}
          onClose={() => setOpenNavbar(false)}
        >
          <Box p="16px" display="flex" justifyContent="space-between">
            <ul className={classes.menuWrapper}>
              <li
                className={classes.menu}
                onClick={() => {
                  window.open(
                    `https://wa.me/${
                      process.env.WHATSAPP_DEFAULT || "6288802870057"
                    }`,
                    "_blank"
                  );
                }}
              >
                {t("contact")}
              </li>
              {onClickAuth && !isLogin && (
                <li className={classes.menu}>
                  <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    className={classes.loginButton}
                    onClick={onClickAuth}
                  >
                    {t("login")}
                  </Button>
                </li>
              )}
            </ul>
            <Close
              className={classes.icon}
              onClick={() => setOpenNavbar(false)}
            />
          </Box>
        </Drawer>
      </Box>
    </Box>
  );
};

export default MenuNavbar;
